import { Routes } from '@angular/router';
import { Register } from './pages/public-user/auth/register/register';
import { ResetPassword } from './pages/public-user/auth/reset-password/reset-password';
import { ResetPasswordSuccess } from './pages/public-user/auth/reset-password/reset-password-success/reset-password-success';
import { Login } from './pages/public-user/auth/login/login';
import { ForgotPasswordPage } from './pages/public-user/auth/forgot-password/forgot-password';
import { OtpVerify } from './pages/public-user/auth/otp-verify/otp-verify';
import { RegisterComponent } from './components/public-user-component/auth/register-component/register-component';
import { NotFound } from './pages/public-user/not-found/not-found';
import { LandingPage } from './pages/public-user/landing-page/landing-page';
import { AdminDashboard } from './pages/admin-dashboard/admin-dashboard';
import { DummyComponent } from './pages/admin-dashboard/dummy/dummy';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';
import { ScopeGuard } from './guards/scope.guard';
import { ForgotPasswordMobileInput } from './components/public-user-component/auth/forgot-password-mobile-input/forgot-password-mobile-input';
import { Products } from './pages/admin-dashboard/products/products';
import { ViewAllProducts } from './pages/admin-dashboard/products/view-all-products/view-all-products';
import { AddProduct } from './pages/admin-dashboard/products/add-product/add-product';
import { ViewProduct } from './pages/admin-dashboard/products/view-product/view-product';
import { UserDashboard } from './pages/user-dashboard/user-dashboard';
import { HomePage } from './pages/user-dashboard/home-page/home-page';
import { Pharmacies as UserPharmacies } from './pages/user-dashboard/pharmacies/pharmacies';
import { UserProducts } from './pages/user-dashboard/user-products/user-products';
import { UserOrders } from './pages/user-dashboard/user-orders/user-orders';
import { Wishlist } from './pages/user-dashboard/wishlist/wishlist';
import { Notifications } from './pages/user-dashboard/notifications/notifications';
import { ChangePassword } from './components/admin-customer-shared-components/update-profile-component/change-password/change-password';
import { DeleteAccount } from './components/admin-customer-shared-components/update-profile-component/delete-account/delete-account';
import { DeactivateAccount } from './components/admin-customer-shared-components/update-profile-component/deactivate-account/deactivate-account';
import { UserManagement } from './pages/admin-dashboard/user-management/user-management';
import { ViewUsers } from './pages/admin-dashboard/user-management/view-users/view-users';
import { AddUser } from './pages/admin-dashboard/user-management/add-user/add-user';
import { Departments } from './pages/admin-dashboard/departments/departments';
import { DepartmentsList } from './pages/admin-dashboard/departments/departments-list/departments-list';
import { DepartmentsCreate } from './pages/admin-dashboard/departments/departments-create/departments-create';
import { NewRequest as UserNewRequest } from './pages/user-dashboard/pharmacies/new-request/new-request';
import { PharmaciesList as UserPharmaciesList } from './components/user-dashboard-component/pharmacies/pharmacies-list/pharmacies-list';
import { EditPharmacy as UserEditPharmacy } from './pages/user-dashboard/pharmacies/edit-pharmacy/edit-pharmacy';
import { Pharmacies as AdminPharmacies } from './pages/admin-dashboard/pharmacies/pharmacies';
import { AdminViewPharmacy } from './pages/admin-dashboard/pharmacies/view-pharmacy/admin-view-pharmacy';
import { AddStock } from './pages/admin-dashboard/products/add-stock/add-stock';
import { EditProduct } from './pages/admin-dashboard/products/edit-product/edit-product';
import { Categories } from './pages/admin-dashboard/categories/categories';
import { ViewAllCategories } from './pages/admin-dashboard/categories/view-all-categories/view-all-categories';
import { RejectionReasons } from './pages/admin-dashboard/rejection-reasons/rejection-reasons';
import { ViewAllRejectionReasons } from './pages/admin-dashboard/rejection-reasons/view-all-rejection-reasons/view-all-rejection-reasons';
import { CreateNewReason } from './pages/admin-dashboard/rejection-reasons/create-new-reason/create-new-reason';
import { EditReason } from './pages/admin-dashboard/rejection-reasons/edit-reason/edit-reason';
import { AddCategory } from './pages/admin-dashboard/categories/add-category/add-category';
import { ViewCategory } from './pages/admin-dashboard/categories/view-category/view-category';
import { EditCategory } from './pages/admin-dashboard/categories/edit-category/edit-category';
import { UserCategories } from './pages/user-dashboard/user-categories/user-categories';
import { UserCompanies } from './pages/user-dashboard/user-companies/user-companies';
import { CategoriesList as UserCategoriesList } from './components/user-dashboard-component/categories/categories-list/categories-list';
import { ViewCategory as UserViewCategory } from './components/user-dashboard-component/categories/view-category/view-category';
import { CompaniesList as UserCompaniesList } from './components/user-dashboard-component/companies/companies-list/companies-list';
import { ViewCompany as UserViewCompany } from './components/user-dashboard-component/companies/view-company/view-company';
import { AdminStatistics } from './components/admin-dashboard-component/admin-statistics/admin-statistics';
import { AdminNotifications } from './pages/admin-dashboard/adminNotifications/admin-notifications';
import { AdminCompanies } from './pages/admin-dashboard/admin-companies/admin-companies';
import { EditCompany } from './pages/admin-dashboard/admin-companies/edit-company/edit-company';
import { ViewCompany } from './pages/admin-dashboard/admin-companies/view-company/view-company';
import { AddCompany } from './pages/admin-dashboard/admin-companies/add-company/add-company';
import { ViewAllCompanies } from './pages/admin-dashboard/admin-companies/view-all-companies/view-all-companies';
import { AdminSubcategories } from './pages/admin-dashboard/admin-subcategories/admin-subcategories';
import { AdminListSubcategories } from './pages/admin-dashboard/admin-subcategories/admin-list-subcategories/admin-list-subcategories';
import { AdminAddSubcategory } from './pages/admin-dashboard/admin-subcategories/admin-add-subcategory/admin-add-subcategory';
import { AdminViewSubcategory } from './pages/admin-dashboard/admin-subcategories/admin-view-subcategory/admin-view-subcategory';
import { AdminEditSubcategory } from './pages/admin-dashboard/admin-subcategories/admin-edit-subcategory/admin-edit-subcategory';
import { AdminSupplier } from './pages/admin-dashboard/admin-supplier/admin-supplier';
import { AdminListSuppliers } from './pages/admin-dashboard/admin-supplier/admin-list-suppliers/admin-list-suppliers';
import { AdminAddSupplier } from './pages/admin-dashboard/admin-supplier/admin-add-supplier/admin-add-supplier';
import { AdminEditSupplier } from './pages/admin-dashboard/admin-supplier/admin-edit-supplier/admin-edit-supplier';
import { AdminGetSupplier } from './pages/admin-dashboard/admin-supplier/admin-get-supplier/admin-get-supplier';
import { AddSubProduct } from './pages/admin-dashboard/products/add-sub-product/add-sub-product';
import { ViewSubProduct } from './pages/admin-dashboard/products/view-sub-product/view-sub-product';
import { StockManagement } from './pages/admin-dashboard/stock-management/stock-management';
import { ViewAllStock } from './pages/admin-dashboard/stock-management/view-all-stock/view-all-stock';
import { AddAllStock } from './pages/admin-dashboard/stock-management/add-all-stock/add-all-stock';
import { OrdersManagement } from './pages/admin-dashboard/orders-management/orders-management';
import { AdminOrders } from './pages/admin-dashboard/orders-management/admin-orders/admin-orders';
import { ViewOrder } from './pages/admin-dashboard/orders-management/view-order/view-order';
import { exitOrderPackagingGuard } from './components/admin-dashboard-component/orders/exit-order-packaging/exit-order-packaging.guard';
import { AttributeManagement } from './pages/admin-dashboard/attribute-management/attribute-management';
import { ViewAllAttributes } from './pages/admin-dashboard/attribute-management/view-all-attributes/view-all-attributes';
import { AddAttribute } from './pages/admin-dashboard/attribute-management/add-attribute/add-attribute';
import { EditAttribute } from './components/admin-dashboard-component/attributes/edit-attribute/edit-attribute';
import { CartManagement } from './pages/admin-dashboard/cart-management/cart-management';
import { AdminCartList } from './pages/admin-dashboard/cart-management/admin-cart-list/admin-cart-list';
import { SCOPES } from './services/scope/scope-constants';
import { ViewUserDetails } from './pages/admin-dashboard/user-management/view-user-details/view-user-details';
import { PharmaciesList } from './pages/admin-dashboard/pharmacies/pharmacies-list/pharmacies-list';
import { CreatePharmacy } from './pages/admin-dashboard/pharmacies/create-pharmacy/create-pharmacy';
import { UpdateProfile } from './pages/admin-user/update-profile/update-profile';
import { UpdateProfileForm } from './components/admin-customer-shared-components/update-profile-component/update-profile-form/update-profile-form';
import { ChangeLanguage } from './components/admin-customer-shared-components/update-profile-component/change-language/change-language';
import { BundlesManagment } from './pages/admin-dashboard/promotions/bundles-managment/bundles-managment';
import { BundleListPage } from './pages/admin-dashboard/promotions/bundles-managment/bundle-list-page/bundle-list-page';
import { CreateBundlePage } from './pages/admin-dashboard/promotions/bundles-managment/create-bundle-page/create-bundle-page';
import { OffersListPage } from './pages/admin-dashboard/promotions/offers-management/offers-list-page/offers-list-page';
import { CreateOffer } from './pages/admin-dashboard/promotions/offers-management/create-offer/create-offer';
import { EditOffer } from './pages/admin-dashboard/promotions/offers-management/edit-offer/edit-offer';
import { OfferDetails } from './pages/admin-dashboard/promotions/offers-management/offer-details/offer-details';
import { AdminApprovedPharmacies } from './pages/admin-dashboard/admin-approved-pharmacies/admin-approved-pharmacies';
import { ApprovedPhList } from './pages/admin-dashboard/admin-approved-pharmacies/approved-ph-list/approved-ph-list';
import { BundleDetails } from './pages/admin-dashboard/promotions/bundles-managment/bundle-details/bundle-details';
import { UserProductDetails } from './pages/user-dashboard/user-product-details/user-product-details';
import { AllOffers } from './pages/user-dashboard/offers/all-offers/all-offers';
import { EditStock } from './pages/admin-dashboard/stock-management/edit-stock/edit-stock';
import { UserOfferDetails } from './pages/user-dashboard/user-offer-details/user-offer-details';
import { UserBundleDetails } from './pages/user-dashboard/user-offer-details/user-bundle-details/user-bundle-details';
import { AdminRouteManagement } from './pages/admin-dashboard/admin-route-management/admin-route-management';
import { AdminRouteInstanceManagement } from './pages/admin-dashboard/admin-route-instance-management/admin-route-instance-management';
import { RouteInstanceList } from './pages/admin-dashboard/admin-route-instance-management/route-instance-list/route-instance-list';
import { RouteList } from './pages/admin-dashboard/admin-route-management/route-list/route-list';

import { PartiallyPackageReasons } from './pages/admin-dashboard/partially-package-reasons/partially-package-reasons';
import { ReasonsList } from './pages/admin-dashboard/partially-package-reasons/reasons-list/reasons-list';
import { ReasonsEdit } from './pages/admin-dashboard/partially-package-reasons/reasons-edit/reasons-edit';
import { ReasonsCreate } from './pages/admin-dashboard/partially-package-reasons/reasons-create/reasons-create';
import { ReasonsDelete } from './pages/admin-dashboard/partially-package-reasons/reasons-delete/reasons-delete';
import { BreadcrumbService } from './services/breadcrumb.service';
import { PartiallyDeliveredReasons } from './pages/admin-dashboard/partially-delivered-reasons/partially-delivered-reasons';
import { PartiallyDeliveredReasonsList } from './pages/admin-dashboard/partially-delivered-reasons/partially-delivered-reasons-list/partially-delivered-reasons-list';
import { PartiallyDeliveredReasonsCreate } from './pages/admin-dashboard/partially-delivered-reasons/partially-delivered-reasons-create/partially-delivered-reasons-create';
import { PartiallyDeliveredReasonsEdit } from './pages/admin-dashboard/partially-delivered-reasons/partially-delivered-reasons-edit/partially-delivered-reasons-edit';

import { CancellationReasonsList } from './pages/admin-dashboard/cancellation-reasons/cancellation-reasons-list/cancellation-reasons-list';
import { CancellationReasonsCreate } from './pages/admin-dashboard/cancellation-reasons/cancellation-reasons-create/cancellation-reasons-create';
import { CancellationReasonsEdit } from './pages/admin-dashboard/cancellation-reasons/cancellation-reasons-edit/cancellation-reasons-edit';

import { UndeliveredReasonsList } from './pages/admin-dashboard/undelivered-reasons/undelivered-reasons-list/undelivered-reasons-list';

import { UndeliveredReasonsCreate } from './pages/admin-dashboard/undelivered-reasons/undelivered-reasons-create/undelivered-reasons-create';
import { UndeliveredReasonsEdit } from './pages/admin-dashboard/undelivered-reasons/undelivered-reasons-edit/undelivered-reasons-edit';
import { AdminInvoice } from './pages/admin-dashboard/admin-invoice/admin-invoice';
import { InvoiceList } from './pages/admin-dashboard/admin-invoice/invoice-list/invoice-list';
import { InvoiceDetailsComponent } from './components/admin-dashboard-component/invoices/invoice-details-component/invoice-details-component';
import { Invoices } from './pages/user-dashboard/invoices/invoices';
import { InvoiceListPharmacist } from './pages/user-dashboard/invoices/invoice-list-pharmacist/invoice-list-pharmacist';
import { CancellationReasons } from './pages/admin-dashboard/cancellation-reasons/cancellation-reasons';
import { AccountStatement } from './pages/admin-dashboard/account-statement/account-statement';
import { AccountStatementAutoComplete } from './pages/admin-dashboard/account-statement/account-statement-auto-complete/account-statement-auto-complete';
import { AccountStatementVeiwList } from './pages/admin-dashboard/account-statement/account-statement-veiw-list/account-statement-veiw-list';
import { InstapayAccounts } from './pages/admin-dashboard/instapay-accounts/instapay-accounts';
import { ListInstapayAccounts } from './pages/admin-dashboard/instapay-accounts/list-instapay-accounts/list-instapay-accounts';
import { PaymentRequestsList } from './pages/admin-dashboard/payment-requests-admin/payment-requests-list/payment-requests-list';
import { InstapayAccount } from './pages/admin-dashboard/instapay-account/instapay-account/instapay-account';
import { InstapayAccountCreate } from './pages/admin-dashboard/instapay-account/instapay-account-create/instapay-account-create';
import { InvoiceDetails } from './pages/user-dashboard/pharmacies/invoice-details/invoice-details';
import { PaymentRequestsAdmin } from './pages/admin-dashboard/payment-requests-admin/payment-requests-admin';
import { PaymentRequestsUser } from './pages/user-dashboard/payment-requests-user/payment-requests-user';
import { BankAccount } from './pages/admin-dashboard/bank-account/bank-account';
import { BankAccountCreate } from './pages/admin-dashboard/bank-account/bank-account-create/bank-account-create';
import { ListBankAccounts } from './pages/admin-dashboard/bank-account/list-bank-accounts/list-bank-accounts';
import { Returns } from './pages/user-dashboard/returns/returns';
import { ReturnsList } from './pages/user-dashboard/returns/returns-list/returns-list';
import { ApprovedPhDetails } from './pages/admin-dashboard/admin-approved-pharmacies/approved-ph-details/approved-ph-details';
import { PhDetailsInfoTap } from './components/admin-dashboard-component/admin-approved-ph-component/ph-details-component/ph-details-info-tap/ph-details-info-tap';
import { ReturnOfRequestsList } from './pages/admin-dashboard/return-of-requests-list/return-of-requests-list';
import { Cities } from './pages/admin-dashboard/cities/cities';
import { CreateCity } from './pages/admin-dashboard/cities/create-city/create-city';
import { ListCities } from './pages/admin-dashboard/cities/list-cities/list-cities';
import { UpdateCity } from './pages/admin-dashboard/cities/update-city/update-city';
import { GovernoratesList } from './pages/admin-dashboard/system-settings/governorates/governorates-list/governorates-list';
import { PharmacySegmentList } from './pages/admin-dashboard/pharmacy-segment/pharmacy-segment-list/pharmacy-segment-list';
import { RegionViewList } from './pages/admin-dashboard/region-view-list/region-view-list';
import { ListOfRegions } from './pages/admin-dashboard/region-view-list/list-of-regions/list-of-regions';
export const routes: Routes = [
  {
    path: '',
    component: LandingPage,
    canActivate: [GuestGuard],
  },
  {
    path: 'register',
    component: Register,
    canActivate: [GuestGuard],
    children: [
      {
        path: '',
        component: RegisterComponent,
      },
    ],
  },
  {
    path: 'login',
    component: Login,
    canActivate: [GuestGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPage,
    canActivate: [GuestGuard],
    children: [
      {
        path: '',
        component: ForgotPasswordMobileInput,
      },
      {
        path: 'otp-verify',
        component: OtpVerify,
      },
    ],
  },
  {
    path: 'reset-password',
    component: ResetPassword,
    canActivate: [GuestGuard],
  },
  {
    path: 'reset-password-success',
    component: ResetPasswordSuccess,
  },
  {
    path: 'admin',
    component: AdminDashboard,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: $localize`:@@breadcrumbDashboard:Dashboard`,
    },
    children: [
      {
        path: '',
        component: AdminStatistics,
        data: {
          breadcrumb: $localize`:@@breadcrumbDashboard:Dashboard`,
        },
      },
      {
        path: 'products',
        component: Products,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.PRODUCTS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbProducts:Products`,
        },
        children: [
          {
            path: '',
            component: ViewAllProducts,
            data: { breadcrumb: $localize`:@@breadcrumbProducts:Products` },
          },
          {
            path: 'add-product',
            component: AddProduct,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PRODUCTS.CREATE],
              breadcrumb: $localize`:@@product.page.title:Add Product`,
            },
          },
          {
            path: 'view-product/:id',
            component: ViewProduct,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PRODUCTS.READ_BY_ID],
              breadcrumb: $localize`:@@breadcrumbViewProduct:View Product`,
            },
          },
          {
            path: 'edit-product/:id',
            component: EditProduct,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PRODUCTS.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditProduct:Edit Product`,
            },
          },
          {
            path: 'add-stock/:id',
            component: AddStock,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.STOCK.ADD_STOCK],
              breadcrumb: $localize`:@@breadcrumbAddIncomingStock:Add Incoming Stock`,
            },
          },
          {
            path: 'add-sub-product/:id',
            component: AddSubProduct,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUB_PRODUCTS.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddSubProduct:Add Sub Product`,
            },
          },
          {
            path: 'view-sub-product/:productId/:subId',
            component: ViewSubProduct,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUB_PRODUCTS.READ_BY_ID],
              breadcrumb: $localize`:@@breadcrumbViewSubProduct:View Sub Product`,
            },
          },
          {
            path: 'edit-sub-product/:id/:subId',
            component: EditProduct,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUB_PRODUCTS.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditSubProduct:Edit Sub Product`,
            },
          },
        ],
      },
      {
        path: 'approved-pharmacies',
        component: AdminApprovedPharmacies,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.PHARMACIES.READ_ALL_APPROVED, SCOPES.PHARMACIES.READ_ASSIGNED_APPROVED],
          breadcrumb: $localize`:@@breadcrumbPharmacies:Pharmacies`,
        },
        children: [
          {
            path: '',
            component: ApprovedPhList,
            data: { breadcrumb: $localize`:@@breadcrumbPharmacies:Pharmacies` },
          },
          {
            path: 'view/:id',
            component: ApprovedPhDetails,
            data: {
              breadcrumb: $localize`:@@breadcrumbPharmacies:Pharmacies`,
            },
          },
        ],
      },
      {
        path: 'requests',
        component: DummyComponent,
        canActivate: [ScopeGuard],
        data: { breadcrumb: $localize`:@@breadcrumbRequests:Requests` },
      },
      {
        path: 'orders',
        component: OrdersManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.ORDERS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbOrders:Orders`,
        },
        children: [
          {
            path: '',
            component: AdminOrders,
            data: { breadcrumb: $localize`:@@breadcrumbOrders:Orders` },
          },
          {
            path: 'view-order/:id',
            component: ViewOrder,
            canActivate: [ScopeGuard],
            // TEMP: disabled during testing — re-enable navigation guard
            // canDeactivate: [exitOrderPackagingGuard],
            data: {
              scopeIds: [SCOPES.ORDERS.READ],
              breadcrumb: $localize`:@@breadcrumbViewOrders:View Order`,
            },
          },
        ],
      },

      {
        path: 'returns-requests',
        component: ReturnOfRequestsList,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbReturns:Returns`,
        },
        children: [
          {
            path: '',
            component: ReturnOfRequestsList,
            data: {
              breadcrumb: $localize`:@@breadcrumbReturns:Returns`,
            },
          },
        ],
      },

      {
        path: 'stock',
        component: StockManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.STOCK.READ_STOCKS],
          breadcrumb: $localize`:@@breadcrumbStocks:Stock`,
        },
        children: [
          {
            path: '',
            component: ViewAllStock,
            data: { breadcrumb: $localize`:@@breadcrumbStocks:Stock` },
          },
          {
            path: 'add-stock',
            component: AddAllStock,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.STOCK.ADD_STOCK],
              breadcrumb: $localize`:@@breadcrumbAddStock:Add Stock`,
            },
          },
          {
            path: 'edit-stock/:id',
            component: EditStock,
          },
        ],
      },

      {
        path: 'account-statement',
        component: AccountStatement,
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.PHARMACY_STATEMENT_ACCOUNT.READ],
          breadcrumb: $localize`:@@breadcrumbPharmacyStatementAccount:Account Statement`,
        },
        children: [
          {
            path: '',
            component: AccountStatementAutoComplete,
            data: {
              breadcrumb: $localize`:@@breadcrumbPharmacyStatementAccount:Account Statement`,
            },
          },
          {
            path: 'view-account-statement/:id',
            component: AccountStatementVeiwList,
            canActivate: [ScopeGuard],
            data: {
              // scopeIds: [SCOPES.PHARMACY_STATEMENT_ACCOUNT.READ],
              breadcrumb: $localize`:@@breadcrumbViewPharmacyStatementAccount:Account Statement`,
            },
          },
        ],
      },

      {
        path: 'attributes',
        component: AttributeManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.GLOBAL_ATTRIBUTES.READ],
          breadcrumb: $localize`:@@breadcrumbAttributes:Attributes`,
        },
        children: [
          {
            path: '',
            component: ViewAllAttributes,
            data: { breadcrumb: $localize`:@@breadcrumbAttributes:Attributes` },
          },
          {
            path: 'add-attribute',
            component: AddAttribute,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.GLOBAL_ATTRIBUTES.CREATE, SCOPES.GLOBAL_ATTRIBUTES.CREATE_VALUES],
              breadcrumb: $localize`:@@breadcrumbAddAttribute:Add Attribute`,
            },
          },
          {
            path: 'edit-attribute',
            component: EditAttribute,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.GLOBAL_ATTRIBUTES.UPDATE_KEY, SCOPES.GLOBAL_ATTRIBUTES.UPDATE_VALUE],
              breadcrumb: $localize`:@@breadcrumbEditAttribute:Edit Attribute`,
            },
          },
        ],
      },
      {
        path: 'user-management',
        component: UserManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.USERS.READ_ALL_SCOPES],
          breadcrumb: $localize`:@@breadcrumbUserManagement:User Management`,
        },
        children: [
          {
            path: '',
            component: ViewUsers,
            data: { breadcrumb: $localize`:@@breadcrumbUserManagement:User Management` },
          },
          {
            path: 'add-user',
            component: AddUser,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.USERS.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddUser:Add User`,
            },
          },
          {
            path: 'view/:id',
            component: ViewUserDetails,
            data: { breadcrumb: $localize`:@@breadcrumbViewUser:View User` },
          },
        ],
      },
      {
        path: 'departments',
        component: Departments,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.USERS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbDepartments:Departments`,
        },
        children: [
          {
            path: '',
            component: DepartmentsList,
            data: { breadcrumb: $localize`:@@breadcrumbDepartments:Departments` },
          },
          {
            path: 'create',
            component: DepartmentsCreate,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.USERS.READ_ALL],
              breadcrumb: $localize`:@@breadcrumbCreateDepartment:Create Department`,
            },
          },
          {
            path: 'view-department/:id',
            loadComponent: () =>
              import('./pages/admin-dashboard/departments/departments-view/departments-view').then(
                (m) => m.DepartmentsView,
              ),
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.USERS.READ_ALL],
              breadcrumb: $localize`:@@breadcrumbViewDepartment:View Department Details`,
            },
          },
          {
            path: 'edit-department/:id',
            loadComponent: () =>
              import('./pages/admin-dashboard/departments/departments-edit/departments-edit').then(
                (m) => m.DepartmentsEdit,
              ),
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.USERS.READ_ALL],
              breadcrumb: $localize`:@@breadcrumbEditDepartment:Edit Department`,
            },
          },
        ],
      },
      {
        path: 'pharmacies',
        component: AdminPharmacies,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.PHARMACIES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbPharmaciesRequests:Pharmacies Requests`,
        },
        children: [
          {
            path: '',
            component: PharmaciesList,
            data: { breadcrumb: $localize`:@@breadcrumbPharmaciesRequests:Pharmacies Requests` },
          },
          {
            path: 'view/:id',
            component: AdminViewPharmacy,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PHARMACIES.READ_DETAILS, SCOPES.PHARMACIES.READ_REQUEST_DETAILS],
              breadcrumb: $localize`:@@breadcrumbViewPharmacy:View Pharmacy`,
            },
          },
          {
            path: 'create-pharmacy',
            component: CreatePharmacy,
            data: { breadcrumb: $localize`:@@breadcrumbAddPharmacy:Add Pharmacy` },
          },
        ],
      },
      {
        path: 'companies',
        component: AdminCompanies,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.COMPANIES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbCompanies:Companies`,
        },
        children: [
          {
            path: '',
            component: ViewAllCompanies,
            data: { breadcrumb: $localize`:@@breadcrumbCompanies:Companies` },
          },
          {
            path: 'add-company',
            component: AddCompany,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.COMPANIES.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddCompany:Add Company`,
            },
          },
          {
            path: 'view-company/:id',
            component: ViewCompany,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.COMPANIES.READ_BY_ID],
              breadcrumb: $localize`:@@breadcrumbViewCompany:View Company`,
            },
          },
          {
            path: 'edit-company/:id',
            component: EditCompany,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.COMPANIES.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditCompany:Edit Company`,
            },
          },
        ],
      },
      {
        path: 'governorates',
        component: GovernoratesList,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@governorates:governorates`,
        },
        children: [
          {
            path: '',
            component: GovernoratesList,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@governorates:governorates`,
            },
          },
        ],
      },
      {
        path: 'cities/view-city-details/:id',
        loadComponent: () =>
          import('./pages/admin-dashboard/cities/view-city-details/view-city-details').then((m) => m.ViewCityDetails),
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbViewCity:City Details`,
        },
      },
      {
        path: 'cities/:id',
        component: Cities,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@cities:Cities`,
        },
        children: [
          {
            path: '',
            component: ListCities,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@cities:Cities`,
            },
          },
          {
            path: 'create-new-city',
            component: CreateCity,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@addcity:Add city`,
            },
          },
        ],
      },

      {
        path: 'regions/:cityId',
        component: RegionViewList,
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.Regions.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbRegions:Regions`,
        },
        children: [
          {
            path: '',
            component: ListOfRegions,
            data: {
              breadcrumb: $localize`:@@breadcrumbRegions:Regions`,
            },
          },
        ],
      },
      {
        path: 'add-region',
        loadComponent: () =>
          import('./pages/admin-dashboard/region-view-list/create-regions/create-regions').then((m) => m.CreateRegions),
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.REGIONS?.CREATE],
          breadcrumb: $localize`:@@breadcrumbAddRegion:Add Region`,
        },
      },
      {
        path: 'edit-region/:id',
        loadComponent: () =>
          import('./pages/admin-dashboard/region-view-list/edit-regions/edit-regions').then((m) => m.EditRegions),
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.REGIONS.UPDATE],
          breadcrumb: $localize`:@@breadcrumbEditRegion:Edit Region`,
        },
      },

      {
        path: 'view-region-details/:id',
        loadComponent: () =>
          import('./pages/admin-dashboard/region-view-list/regions-view-details/regions-view-details').then(
            (m) => m.RegionsViewDetails,
          ),
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.REGIONS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbViewRegion:Region Details`,
        },
      },

      {
        path: 'cities/edit-city/:id',
        component: UpdateCity,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@editcity:Edit city`,
        },
      },
      {
        path: 'categories',
        component: Categories,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.CATEGORIES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbCategories:Categories`,
        },
        children: [
          {
            path: '',
            component: ViewAllCategories,
            data: { breadcrumb: $localize`:@@breadcrumbCategories:Categories` },
          },
          {
            path: 'add-category',
            component: AddCategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CATEGORIES.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddCategory:Add Category`,
            },
          },
          {
            path: 'view-category/:id',
            component: ViewCategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CATEGORIES.READ_BY_ID],
              breadcrumb: $localize`:@@breadcrumbViewCategory:View Category`,
            },
          },
          {
            path: 'edit-category/:id',
            component: EditCategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CATEGORIES.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditCategory:Edit Category`,
            },
          },
        ],
      },
      {
        path: 'partially-package-reasons',
        component: PartiallyPackageReasons,
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.CATEGORIES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbPartiallyPackageReasons:Partially Package Reasons`,
        },
        children: [
          {
            path: '',
            component: ReasonsList,
            data: {
              breadcrumb: $localize`:@@breadcrumbPartiallyPackageReasons:Partially Package Reasons`,
            },
          },
          {
            path: 'add-reason',
            loadComponent: () =>
              import('./pages/admin-dashboard/partially-package-reasons/reasons-create/reasons-create').then(
                (m) => m.ReasonsCreate,
              ),
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CATEGORIES.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddPartiallyPackageReason:Create New Reason`,
            },
          },
          {
            path: 'edit-reason/:id',
            loadComponent: () =>
              import('./pages/admin-dashboard/partially-package-reasons/reasons-edit/reasons-edit').then(
                (m) => m.ReasonsEdit,
              ),
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CATEGORIES.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditPartiallyPackageReason:Edit Reason`,
            },
          },
        ],
      },
      {
        path: 'subcategories',
        component: AdminSubcategories,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.SUB_CATEGORIES.READ_ALL],
          breadcrumb: $localize`:@@subcategoriesSectionTitle:Subcategories`,
        },
        children: [
          {
            path: '',
            component: AdminListSubcategories,
          },
          {
            path: 'add-subcategory',
            component: AdminAddSubcategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUB_CATEGORIES.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddSubcategory:Add Subcategory`,
            },
          },
          {
            path: 'view-subcategory/:id',
            component: AdminViewSubcategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUB_CATEGORIES.READ_BY_ID],
              breadcrumb: $localize`:@@breadcrumbViewSubcategory:View Subcategory`,
            },
          },
          {
            path: 'edit-subcategory/:id',
            component: AdminEditSubcategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUB_CATEGORIES.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditSubcategory:Edit Subcategory`,
            },
          },
        ],
      },
      {
        path: 'undelivered-reasons',
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.UNDELIVERED_REASONS?.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbUndeliveredReasons:Undelivered Reasons`,
        },
        children: [
          {
            path: '',
            component: UndeliveredReasonsList,
            data: { breadcrumb: $localize`:@@breadcrumbUndeliveredReasons:Undelivered Reasons` },
          },
          {
            path: 'create',
            component: UndeliveredReasonsCreate,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.UNDELIVERED_REASONS?.CREATE],
              breadcrumb: $localize`:@@addUndeliveredReason:Create New Reason`,
            },
          },
          {
            path: 'edit/:id',
            component: UndeliveredReasonsEdit,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.UNDELIVERED_REASONS?.UPDATE],
              breadcrumb: $localize`:@@editUndeliveredReason:Edit Reason`,
            },
          },
        ],
      },

      {
        path: 'partially-delivered-reasons',
        component: PartiallyDeliveredReasons,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.PARTIALLY_DELIVERED_REASONS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbPartiallyDeliveredReasons:Partially Delivered Reasons`,
        },
        children: [
          {
            path: '',
            component: PartiallyDeliveredReasonsList,
            data: {
              breadcrumb: $localize`:@@breadcrumbPartiallyDeliveredReasons:Partially Delivered Reasons`,
            },
          },
          {
            path: 'create-partially-delivered-reason',
            component: PartiallyDeliveredReasonsCreate,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PARTIALLY_DELIVERED_REASONS.CREATE],
              breadcrumb: $localize`:@@breadcrumbCreatePartiallyDeliveredReason:Create Partially Delivered Reason`,
            },
          },
          {
            path: 'edit-partially-delivered-reason/:id',
            component: PartiallyDeliveredReasonsEdit,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PARTIALLY_DELIVERED_REASONS.UPDATE],
              breadcrumb: $localize`:@@breadcrumbEditPartiallyDeliveredReason:Edit Partially Delivered Reason`,
            },
          },
        ],
      },

      {
        path: 'pharmacy-segments',
        canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.PHARMACY_SEGMENTS?.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbPharmacySegments:Pharmacy Segments`,
        },
        children: [
          {
            path: '',
            component: PharmacySegmentList,
            data: { breadcrumb: $localize`:@@breadcrumbPharmacySegments:Pharmacy Segments` },
          },
        ],
      },
      {
        path: 'instapay-account',
        component: InstapayAccount,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbInstapayAccount:InstaPay Account`,
        },
        children: [
          {
            path: 'add-instapay-account',
            component: InstapayAccountCreate,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbAddInstapayAccount:Add InstaPay Account`,
            },
          },
        ],
      },

      {
        path: 'cancellation',
        component: CancellationReasons,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.CANCELLATION_REASONS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbCancellationReasons:Cancellation Reasons`,
        },
        children: [
          {
            path: '',
            component: CancellationReasonsList,
            data: { breadcrumb: $localize`:@@breadcrumbCancellationReasons:Cancellation Reasons` },
          },
          {
            path: 'create-cancellation-reason',
            component: CancellationReasonsCreate,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CANCELLATION_REASONS.CREATE],
              breadcrumb: $localize`:@@cancellationReasonsCreate:Create New Reason`,
            },
          },
          {
            path: 'edit-cancellation-reason/:id',
            component: CancellationReasonsEdit,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CANCELLATION_REASONS.UPDATE],
              breadcrumb: $localize`:@@breadcrumbCancellationReasonedit:Edit Cancellation Reason`,
            },
          },
        ],
      },
      {
        path: 'invoices',
        component: AdminInvoice,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbInvoiceAdmin:Invoices`,
        },
        children: [
          {
            path: '',
            component: InvoiceList,
          },
          {
            path: 'invoice-details/:id',
            loadComponent: () =>
              import('./pages/admin-dashboard/invoices/invoice-details/invoice-details').then(
                (m) => m.InvoiceDetailsPage,
              ),
            data: {
              breadcrumb: $localize`:@@breadcrumbInvoiceDetails:View Invoice Details`,
            },
          },
        ],
      },
      {
        path: 'instapay-Accounts',
        component: InstapayAccounts,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@instapayAccount:InstaPay Account`,
        },
        children: [
          {
            path: '',
            component: ListInstapayAccounts,
            data: { breadcrumb: $localize`:@@instapayAccount:InstaPay Account` },
          },
        ],
      },
      {
        path: 'bank-account',
        component: BankAccount,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbBankAccount:Bank Account`,
        },
        children: [
          {
            path: '',
            component: ListBankAccounts,
            canActivate: [ScopeGuard],
          },
          {
            path: 'add-bank-account',
            component: BankAccountCreate,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbAddBankAccount:Add Bank Account`,
            },
          },
        ],
      },
      {
        path: 'payment-requests',
        component: PaymentRequestsAdmin,
        // canActivate: [ScopeGuard],
        data: {
          // scopeIds: [SCOPES.PAYMENT_REQUESTS?.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbPaymentRequests:Payment Requests`,
        },
        children: [
          {
            path: '',
            component: PaymentRequestsList,
            data: { breadcrumb: $localize`:@@breadcrumbPaymentRequests:Payment Requests` },
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./components/admin-customer-shared-components/create-payment-request/create-payment-request').then(
                (c) => c.CreatePaymentRequest,
              ),
            data: {
              breadcrumb: $localize`:@@breadcrumbCreatePaymentRequest:Create Payment Request`,
            },
          },
          {
            path: 'view-payment-request-details/:id',
            loadComponent: () =>
              import('./pages/payment-request-info-tab/payment-request-info-details/payment-request-info-details').then(
                (c) => c.PaymentRequestInfoDetails,
              ),
            canActivate: [ScopeGuard],
            data: {
              // scopeIds: [SCOPES.PAYMENT_REQUESTS.READ_DETAILS],
              breadcrumb: $localize`:@@breadcrumbViewPaymentReqDetails:View Payment Request Details`,
            },
          },
          {
            path: 'modify-payment-request/:id',
            loadComponent: () =>
              import('./pages/admin-dashboard/payment-requests-admin/payment-request-modification/payment-request-modification').then(
                (c) => c.PaymentRequestModificationPage,
              ),
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbModifyPaymentRequest:Modify Payment Request`,
            },
          },
        ],
      },
      {
        path: 'rejection-reasons',
        // component: RejectionReasons,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbRejectionReasons:Rejection Reasons`,
        },
        children: [
          {
            path: '',
            component: ViewAllRejectionReasons,
          },
          {
            path: 'create-new-reason',
            component: CreateNewReason,
            canActivate: [ScopeGuard],
            data: {
              // scopeIds: [SCOPES.CATEGORIES.CREATE],

              breadcrumb: $localize`:@@breadcrumbCreateNewReason:Create New Reason`,
            },
          },
          {
            path: 'edit-reason/:reasonId',
            component: EditReason,
            canActivate: [ScopeGuard],
            data: {
              // scopeIds: [SCOPES.CATEGORIES.CREATE],
              breadcrumb: $localize`:@@breadcrumbEditReason:Edit Reason`,
            },
          },
        ],
      },
      {
        path: 'cart',
        component: CartManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.ADMIN_CART.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbCart:Cart`,
        },
        children: [
          {
            path: '',
            component: AdminCartList,
            data: { breadcrumb: $localize`:@@breadcrumbCart:Cart` },
          },
          {
            path: 'view-cart/:id',
            loadComponent: () =>
              import('./pages/admin-dashboard/cart-management/admin-cart-details/admin-cart-details').then(
                (module) => module.AdminCartDetails,
              ),
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.ADMIN_CART.READ_DETAILS],
              breadcrumb: $localize`:@@breadcrumbViewCart:View Cart`,
            },
          },
        ],
      },
      {
        path: 'routes',
        component: AdminRouteManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.ROUTES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbRoute:Routes`,
        },
        children: [
          {
            path: '',
            component: RouteList,
            data: { breadcrumb: $localize`:@@breadcrumbRoute:Routes` },
          },
          {
            path: 'view-route/:id',
            loadComponent: () =>
              import('../app/pages/admin-dashboard/admin-route-management/route-details/route-details').then(
                (module) => module.RouteDetails,
              ),
            data: { breadcrumb: $localize`:@@breadcrumbRouteDetails:RouteDetails` },
          },
        ],
      },
      {
        path: 'route-instances',
        component: AdminRouteInstanceManagement,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.ROUTES_INSTANCE.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbRouteInstances:RouteInstances`,
        },
        children: [
          {
            path: '',
            component: RouteInstanceList,
            data: { breadcrumb: $localize`:@@breadcrumbRouteInstances:RouteInstances` },
          },
          {
            path: 'view-route-instance/:id',
            loadComponent: () =>
              import('../app/pages/admin-dashboard/admin-route-instance-management/routes-instances-details/routes-instances-details').then(
                (module) => module.RoutesInstancesDetails,
              ),
            data: { breadcrumb: $localize`:@@breadcrumbRouteInstanceDetails:Route Instance Details` },
          },
        ],
      },
      {
        path: 'suppliers',
        component: AdminSupplier,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.SUPPLIERS.READ_ALL],
          breadcrumb: $localize`:@@adminSidebarSuppliers:Suppliers`,
        },
        children: [
          {
            path: '',
            component: AdminListSuppliers,
            data: { breadcrumb: $localize`:@@adminSidebarSuppliers:Suppliers` },
          },
          {
            path: 'add-supplier',
            component: AdminAddSupplier,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUPPLIERS.CREATE],
              breadcrumb: $localize`:@@breadcrumbAddSupplier:Add Supplier`,
            },
          },
          {
            path: 'view-supplier/:id',
            component: AdminGetSupplier,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUPPLIERS.READ],
              breadcrumb: $localize`:@@adminSuppliersActionView:View Supplier`,
            },
          },
          {
            path: 'edit-supplier/:id',
            component: AdminEditSupplier,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.SUPPLIERS.UPDATE],
              breadcrumb: $localize`:@@adminSuppliersActionEdit:Edit Supplier`,
            },
          },
        ],
      },
      {
        path: 'notifications',
        component: AdminNotifications,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.NOTIFICATIONS.READ_WEB_PUSH, SCOPES.NOTIFICATIONS.MARK_WEB_PUSH_READ],
          breadcrumb: $localize`:@@breadcrumbNotifications:Notifications`,
        },
      },
      {
        path: 'offers',
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.OFFERS.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbOffers:Offers`,
        },
        children: [
          { path: '', component: OffersListPage, data: { breadcrumb: $localize`:@@breadcrumbOffers:Offers` } },
          {
            path: 'offer-details/:id',
            component: OfferDetails,
            data: { breadcrumb: $localize`:@@breadcrumbAdminOfferDetails:Offer Details` },
          },
          {
            path: 'create-offer',
            component: CreateOffer,
            data: { breadcrumb: $localize`:@@breadcrumbCreateOffer:Create Offer` },
          },
          {
            path: 'edit-offer/:id',
            component: EditOffer,
            data: { breadcrumb: $localize`:@@adminOffersActionEdit:Edit Offer` },
          },
        ],
      },
      {
        path: 'bundles',
        component: BundlesManagment,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.BUNDLES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbBundles:Bundles`,
        },
        children: [
          {
            path: '',
            component: BundleListPage,
            data: { breadcrumb: $localize`:@@breadcrumbBundles:Bundles` },
          },
          {
            path: 'bundle-details/:id',
            component: BundleDetails,
            data: { breadcrumb: $localize`:@@breadcrumbAdminBundleDetails:Bundle Details` },
          },
          {
            path: 'create-bundle',
            component: CreateBundlePage,
            data: {
              scopeIds: [SCOPES.BUNDLES.ADD],
              breadcrumb: $localize`:@@breadcrumbCreateBundle:Add Bundle`,
            },
          },
        ],
      },
      {
        path: 'report',
        component: DummyComponent,
        data: { breadcrumb: $localize`:@@breadcrumbReport:Report` },
      },
      {
        path: 'profile',
        component: UpdateProfile,
        data: { breadcrumb: $localize`:@@profileBreadcrumb:Profile` },
      },
      {
        path: 'profile/update',
        component: UpdateProfileForm,
        data: { breadcrumb: $localize`:@@profileUpdateBreadcrumb:Update Profile` },
      },
      {
        path: 'profile/change-password',
        component: ChangePassword,
        data: { breadcrumb: $localize`:@@profileChangePasswordBreadcrumb:Change Password` },
      },
      {
        path: 'profile/delete-account',
        component: DeleteAccount,
        data: { breadcrumb: $localize`:@@profileDeleteAccountBreadcrumb:Delete Account` },
      },
      {
        path: 'profile/deactivate-account',
        component: DeactivateAccount,
        data: { breadcrumb: $localize`:@@profileDeactivateAccountBreadcrumb:Deactivate Account` },
      },
      {
        path: 'profile/change-language',
        component: ChangeLanguage,
        data: { breadcrumb: $localize`:@@profileChangeLanguageBreadcrumb:Change Language` },
      },
      {
        path: '**',
        component: NotFound,
      },
    ],
  },
  {
    path: 'user',
    component: UserDashboard,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: $localize`:@@breadcrumbDashboard:Dashboard`,
    },
    children: [
      {
        path: '',
        component: HomePage,
        data: { breadcrumb: $localize`:@@breadcrumbDashboard:Dashboard` },
      },
      {
        path: 'offers',
        data: { breadcrumb: $localize`:@@breadcrumbOffers:Offers` },
        children: [
          {
            path: '',
            component: AllOffers,
          },
          {
            path: 'view-offer/:id',
            component: UserOfferDetails,
            data: {
              breadcrumb: $localize`:@@breadcrumbOfferDetails:viewOffer`,
            },
          },
          {
            path: 'view-bundle/:id',
            component: UserBundleDetails,
          },
        ],
      },
      {
        path: 'pharmacies',
        component: UserPharmacies,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.PHARMACIES.READ_ALL],
          breadcrumb: $localize`:@@breadcrumbPharmacies:Pharmacies`,
        },
        children: [
          {
            path: '',
            component: UserPharmaciesList,
            data: { breadcrumb: $localize`:@@breadcrumbPharmacies:Pharmacies` },
          },
          {
            path: 'new-request',
            component: UserNewRequest,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PHARMACIES.CREATE_SUBMIT],
              breadcrumb: $localize`:@@breadcrumbNewRequest:New Request`,
            },
          },
          {
            path: 'edit/:id',
            component: UserEditPharmacy,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PHARMACIES.READ_DETAILS, SCOPES.PHARMACIES.READ_REQUEST_DETAILS],
              breadcrumb: $localize`:@@breadcrumbEditPharmacy:Edit Pharmacy`,
            },
          },
          {
            path: 'view/:id',
            component: AdminViewPharmacy,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.PHARMACIES.READ_DETAILS, SCOPES.PHARMACIES.READ_REQUEST_DETAILS],
              breadcrumb: $localize`:@@breadcrumbViewPharmacy:View Pharmacy`,
            },
          },
        ],
      },
      {
        path: 'products',
        data: {
          breadcrumb: $localize`:@@breadcrumbProducts:Products`,
        },
        children: [
          { path: '', component: UserProducts },
          {
            path: 'view-product/:id',
            component: UserProductDetails,
          },
        ],
      },
      {
        path: 'categories',
        component: UserCategories,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbCategories:Categories`,
        },
        children: [
          {
            path: '',
            component: UserCategoriesList,
            data: { breadcrumb: $localize`:@@breadcrumbCategories:Categories` },
          },
          {
            path: 'view/:id',
            component: UserViewCategory,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbViewCategory:View Category`,
            },
          },
        ],
      },
      {
        path: 'cart',
        loadComponent: () => import('./pages/user-dashboard/user-cart/user-cart').then((module) => module.UserCart),
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbCart:Cart`,
        },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/user-dashboard/user-cart/user-cart').then((module) => module.UserCart),
            data: { breadcrumb: $localize`:@@breadcrumbCart:Cart` },
          },
          {
            path: 'view/:id',
            component: UserViewCategory,
            canActivate: [ScopeGuard],
            data: {
              scopeIds: [SCOPES.CATEGORIES.READ_BY_ID],
              breadcrumb: $localize`:@@breadcrumbViewCategory:View Category`,
            },
          },
        ],
      },
      {
        path: 'companies',
        component: UserCompanies,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbCompanies:Companies`,
        },
        children: [
          {
            path: '',
            component: UserCompaniesList,
            data: { breadcrumb: $localize`:@@breadcrumbCompanies:Companies` },
          },
          {
            path: 'view/:id',
            component: UserViewCompany,
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbViewCompany:View Company`,
            },
          },
        ],
      },
      {
        path: 'wishlist',
        component: Wishlist,
        data: { breadcrumb: $localize`:@@breadcrumbWishlist:Wishlist` },
      },
      {
        path: 'notifications',
        component: Notifications,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.NOTIFICATIONS.READ_WEB_PUSH, SCOPES.NOTIFICATIONS.MARK_WEB_PUSH_READ],
          breadcrumb: $localize`:@@breadcrumbNotifications:Notifications`,
        },
      },
      {
        path: 'payment-requests',
        component: PaymentRequestsUser,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/user-dashboard/payment-requests-user/payment-requests-pharmacist-list/payment-requests-pharmacist-list').then(
                (c) => c.PaymentRequestsPharmacistList,
              ),
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbPaymentRequests:Payment Requests`,
            },
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./components/admin-customer-shared-components/create-payment-request/create-payment-request').then(
                (c) => c.CreatePaymentRequest,
              ),
            data: {
              breadcrumb: $localize`:@@breadcrumbCreatePaymentRequest:Create Payment Request`,
            },
          },
          {
            path: 'view-payment-request-details/:id',
            loadComponent: () =>
              import('./pages/user-dashboard/user-payment-request-info-tab/user-payment-request-info-tab').then(
                (c) => c.UserPaymentRequestInfoDetails,
              ),
            canActivate: [ScopeGuard],
            data: {
              // scopeIds: [SCOPES.PAYMENT_REQUESTS.READ_DETAILS],
              breadcrumb: $localize`:@@breadcrumbViewPaymentReqDetails:View Payment Request Details`,
            },
          },
          {
            path: 'modify-payment-request/:id',
            loadComponent: () =>
              import('./pages/user-dashboard/payment-requests-user/payment-request-modification/payment-request-modification').then(
                (c) => c.PaymentRequestModificationUserPage,
              ),
            canActivate: [ScopeGuard],
            data: {
              breadcrumb: $localize`:@@breadcrumbModifyPaymentRequest:Modify Payment Request`,
            },
          },
        ],
      },

      {
        path: 'orders',
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbOrders:Orders`,
        },
        children: [
          {
            path: '',
            component: UserOrders,
            data: {
              scopeIds: [SCOPES.ORDERS.READ],
            },
          },
          {
            path: 'view/:id',
            component: ViewOrder,
            data: {
              scopeIds: [SCOPES.ORDERS.READ],
              role: 'pharmacist',
            },
          },
        ],
      },
      {
        path: 'returns',
        component: Returns,
        canActivate: [ScopeGuard],
        data: {
          breadcrumb: $localize`:@@breadcrumbReturns:Returns`,
        },
        children: [
          {
            path: '',
            component: ReturnsList,
            data: {},
          },
        ],
      },
      {
        path: 'invoices',
        component: Invoices,
        canActivate: [ScopeGuard],
        data: {},
        children: [
          {
            path: '',
            component: InvoiceListPharmacist,
            data: { breadcrumb: $localize`:@@breadcrumbInvoices:Invoices` },
          },
          {
            path: 'invoice-details/:id',
            component: InvoiceDetails,
            data: {
              breadcrumb: $localize`:@@breadcrumbInvoiceDetails:View Invoice Details`,
            },
          },
        ],
      },
      {
        path: 'wishlist',
        component: Wishlist,
        data: { breadcrumb: $localize`:@@breadcrumbWishlist:Wishlist` },
      },
      {
        path: 'notifications',
        component: Notifications,
        canActivate: [ScopeGuard],
        data: {
          scopeIds: [SCOPES.NOTIFICATIONS.READ_WEB_PUSH, SCOPES.NOTIFICATIONS.MARK_WEB_PUSH_READ],
          breadcrumb: $localize`:@@breadcrumbNotifications:Notifications`,
        },
      },
      {
        path: 'profile',
        component: UpdateProfile,
        data: { breadcrumb: $localize`:@@profileBreadcrumb:Profile` },
      },
      {
        path: 'profile/change-password',
        component: ChangePassword,
        data: { breadcrumb: $localize`:@@profileChangePasswordBreadcrumb:Change Password` },
      },
      {
        path: 'profile/delete-account',
        component: DeleteAccount,
        data: { breadcrumb: $localize`:@@profileDeleteAccountBreadcrumb:Delete Account` },
      },
      {
        path: 'profile/deactivate-account',
        component: DeactivateAccount,
        data: { breadcrumb: $localize`:@@profileDeactivateAccountBreadcrumb:Deactivate Account` },
      },
      {
        path: 'profile/change-language',
        component: ChangeLanguage,
        data: { breadcrumb: $localize`:@@profileChangeLanguageBreadcrumb:Change Language` },
      },
      {
        path: 'profile/update',
        component: UpdateProfileForm,
        data: { breadcrumb: $localize`:@@profileUpdateBreadcrumb:Update Profile` },
      },
      {
        path: '**',
        component: NotFound,
      },
    ],
  },
  {
    path: '**',
    component: NotFound,
  },
];
